import React, { Fragment, createRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { compose } from 'recompose';

import { Button } from 'shared/components';
import { withEscHandler } from 'shared/hocs/modalWithEscHandler';

import theme from './TermsAndConditionsModal.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  onCancel: PropTypes.func.isRequired,
  body: PropTypes.string.isRequired,
};

const TermsAndConditionsModal = ({
  intl,
  onCancel,
  body,
}) => {
  const scrollableContainer = createRef();
  useEffect(() => {
    setTimeout(() => scrollableContainer.current.scrollTo(0, 0), 10);
  }, []);

  return (
    <Fragment>
      <div className={ theme.body }>
        <div
          ref={ scrollableContainer }
          className={ theme.content }
          dangerouslySetInnerHTML={{ __html: body }}
          tabIndex={ 0 }
        />
      </div>
      <div className={ theme.footer }>
        <Button
          testId="modal-tos-close-button"
          buttonType="naked"
          label={ intl.formatMessage({ id: 'General.Close', defaultMessage: '** Close' }) }
          onClick={ onCancel }
        />
      </div>
    </Fragment>
  );
};
TermsAndConditionsModal.propTypes = propTypes;

export default compose(
  withEscHandler,
  injectIntl,
)(TermsAndConditionsModal);
